
class Record {
  static id({ id }: { id: number | string }): string {
    return `#${String(id).padStart(5, '0')}`;
  }
}

export default Record;
